// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { LabelRepo } from '@client/ng2/modules/endpoints/api/label.repo';
import { ToastService } from '@monsido/angular-shared-components';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { MON_COLORS } from '@client/app/core/constants/helpers/monsido-colors';

@Component({
    selector: 'form-label',
    template: `
        <form name="form" class="form-horizontal" (ngSubmit)="!onSave && form.valid && submit()" #form="ngForm">
            <div class="mon-dialog-header">
                <page-header class="inline-block pt-1" [header]="title"></page-header>
            </div>
            <div class="mon-dialog-body-with-footer bg-white">
                <div class="px-4 py-4">
                    <div class="row">
                        <div class="col-24">
                            <form-field-input
                                [placeholder]="'Label name' | translate"
                                name="name"
                                [ngModel]="label.name"
                                (ngModelChange)="label.name = $event"
                                [required]="true">
                            </form-field-input>
                            <mon-color-simple-picker
                                [colorValue]="label.color"
                                (onValueChange)="label.color = $event">
                            </mon-color-simple-picker>
                        </div>
                        <div class="col-24">
                            <div translate>
                                Label preview
                            </div>
                            <div class="label"
                                 [ngStyle]="{'background-color': label.color, color: (label.color | inverseColorCode)}">
                                {{label.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mon-dialog-footer text-right">
                <button
                    data-test="save-button"
                    [disabled]="onSave || form.invalid"
                    class="btn btn-border-radius btn-marine-blue"
                    type="submit"
                    monEventTrigger="actionTrigger"
                    [monEventParams]="{action: 'label-form-save'}">
                    <span translate>Save</span>
                    <span [ngClass]="{'fas fa-spinner fa-spin fa-fw' : onSave}" aria-hidden="true"></span>
                </button>
            </div>
        </form>
    `,
    standalone: false,
})
export class FormLabelComponent implements OnInit {
    @Input() label?: any;
    @Input() monDialogId?: string;

    title: string = '';
    onSave: boolean = false;

    constructor (
        private monDialog: MonDialog,
        private labelRepo: LabelRepo,
        private translateService: TranslateService,
        private toastService: ToastService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.label = this.label || { name: '', color: '' };
        if (this.label.id === undefined || this.label.id === null) {
            this.title = this.translateService.getString('Create label');
            this.label.color = MON_COLORS.DEFAULT;
        } else {
            this.title = this.translateService.getString('Edit label');
        }
    }

    submit (): void {
        this.onSave = true;
        const params = {
            name: this.label.name,
            color: this.label.color,
        };
        let promise;
        if (this.label.id === undefined || this.label.id === null) {
            promise = this.labelRepo.createLabel(params).then((data) => {
                this.toastService.success(this.translateService.getString('Label created'));
                this.close(data);
            }, () => {});
        } else {
            (params as any).label_id = this.label.id;
            promise = this.labelRepo.updateLabel(params).then((data) => {
                this.toastService.success(this.translateService.getString('Label updated'));
                this.close(data);
            }, () => {});
        }

        promise.catch(() => {
            this.onSave = false;
        });
    }

    private close (data: any): void {
        this.monDialog.close(this.monDialogId, data);
    }
}
